module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-8-89c84c3874055b20b8fcc4b80451ff9d.jpg";